import { __decorate } from "tslib";
import { AsnType, AsnTypeTypes, AsnProp, AsnPropTypes } from "@peculiar/asn1-schema";
import { GeneralName } from "@peculiar/asn1-x509";
import { id_ntQWAC } from "./oids";
export const id_ActivityDescription = `${id_ntQWAC}.6`;
let ActivityDescription = class ActivityDescription {
    constructor(params = {}) {
        this.codeAuthority = new GeneralName();
        this.codeId = new GeneralName();
        this.shortName = "";
        this.shortDescription = "";
        Object.assign(this, params);
    }
};
__decorate([
    AsnProp({ type: GeneralName, context: 0 })
], ActivityDescription.prototype, "codeAuthority", void 0);
__decorate([
    AsnProp({ type: GeneralName, context: 1 })
], ActivityDescription.prototype, "codeId", void 0);
__decorate([
    AsnProp({ type: AsnPropTypes.Utf8String, context: 2 })
], ActivityDescription.prototype, "shortName", void 0);
__decorate([
    AsnProp({ type: AsnPropTypes.Utf8String, context: 3 })
], ActivityDescription.prototype, "shortDescription", void 0);
ActivityDescription = __decorate([
    AsnType({ type: AsnTypeTypes.Sequence })
], ActivityDescription);
export { ActivityDescription };
